import * as types from "../actions/actionTypes";
import { sortBy2Property } from "../lib/listMethods";
const initialState = {
  loading: false,
  data: [],
  error: "",
  isFetched: false,

  hashtag: {},
  showLoading: false,
  showError: "",

  last_item: "",
  storeProcessing: false,
  storeStatus: false,
  removeProcessing: false
};

const Hashtag = (state = initialState, action) => {
  let data;
  switch (action.type) {
    case types.GET_HASHTAG_REQUEST:
      return { ...state, loading: true, error: "", isFetched: false };
    case types.GET_HASHTAG_SUCCESS:
      return {
        ...state,
        data: action.payLoad,
        loading: false,
        isFetched: true
      };
    case types.GET_HASHTAG_FAILURE:
      return { ...state, loading: false, error: action.error };

    case types.SHOW_HASHTAG_REQUEST:
      return { ...state, hashtag: {}, showLoading: true, showError: "" };
    case types.SHOW_HASHTAG_SUCCESS:
      return { ...state, hashtag: action.payLoad, showLoading: false };
    case types.SHOW_HASHTAG_FAILURE:
      return { ...state, showLoading: false, showError: action.error };

    case types.UPDATE_HASHTAG_REQUEST:
      return { ...state, showLoading: true };
    case types.UPDATE_HASHTAG_SUCCESS:
      data = [];
      if (state.data.length) {
        data = state.data.map(item => {
          if (item.id === Number(action.payLoad.id)) {
            return { ...action.payLoad };
          } else {
            return item;
          }
        });
      }
      return {
        ...state,
        hashtag: action.payLoad,
        showLoading: false,
        data: sortBy2Property(data, true, "color", "name")
      };
    case types.UPDATE_HASHTAG_FAILURE:
      return { ...state, showLoading: false };

    case types.STORE_HASHTAG_REQUEST:
      return { ...state, storeProcessing: true };
    case types.STORE_HASHTAG_SUCCESS:
      data = [...state.data];
      let founded = false;
      if (data.length) {
        data = data.map(item => {
          if (item.id === Number(action.payLoad.id)) {
            founded = true;
            return { ...action.payLoad };
          } else {
            return item;
          }
        });
      }
      if (!founded) {
        data.push(action.payLoad);
      }
      return {
        ...state,
        storeProcessing: false,
        last_item: action.payLoad,
        data: sortBy2Property(data, true, "color", "name"),
        storeStatus: true
      };
    case types.STORE_HASHTAG_FAILURE:
      return { ...state, storeProcessing: false, storeStatus: false };

    case types.REMOVE_HASHTAG_REQUEST:
      return { ...state, removeProcessing: true };
    case types.REMOVE_HASHTAG_SUCCESS:
      data = [...state.data]; // because deepCopy is needed :)
      data = data.filter(item => item.id !== Number(action.payLoad));
      return { ...state, data: data, removeProcessing: false };
    case types.REMOVE_HASHTAG_FAILURE:
      return { ...state, removeProcessing: false };
    case types.CLEAR_HASHTAG_LIST:
      return { ...state, data: [], isFetched: false };
    default:
      return state;
  }
};

export default Hashtag;
